export enum HouseholdClaimProductCode {
    PH00 = "PH00",
    PH01 = "PH01",
    PRE2 = "PRE2",
    PRE3 = "PRE3",
}
